import React from 'react'
// libs
import { useNavigate } from 'react-router'
import styled from 'styled-components'
// components
import ExitIconOrigin from '@mui/icons-material/ExitToApp'
// themes
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'

const ExitIcon = styled(ExitIconOrigin)`
  margin-left: 8px;
`

const ExitReportButton: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Button style={CREATE_BUTTON_STYLE} layout={BUTTON_LAYOUTS.DARK_BLUE} onClick={() => navigate(-1)}>
      EXIT REPORT <ExitIcon />
    </Button>
  )
}

export default ExitReportButton
